import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './components/HomePage';
import FarmGuidelines from './components/FarmGuidelines';
import Footer from './components/Footer';
import Navigation from './components/Navigation';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-background relative">
        <Navigation />

        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/farm-guidelines" element={<FarmGuidelines />} />
        </Routes>

        <Footer />

        <Toaster position="top-center" richColors />
      </div>
    </BrowserRouter>
  );
}

export default App;